<template>
  <div>
    <PageHeader :title="title" :items="headerItems" />
    <div class="headerParent d-flex align-items-center justify-content-end">
      <button @click="addButtonFuction('section')" class="btn btn-outline-secondary">+ اضافه کردن بخش</button>
      <button @click="addButtonFuction('question')" class="primary__button">+ اضافه کردن سوال</button>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/layoutComponents/page-header.vue'
export default {
  components: {
    PageHeader,
  },
  data() {
    return {
      headerItems: [
        {
          text: 'داشبورد',
          href: '/',
        },
        {
          text: 'اضافه کردن فرم جدید',
          active: true,
        },
      ],
      title: 'دسته بندی محصولات',
    }
  },
  methods: {
    addButtonFuction(payload) {
      if (payload === 'question') {
        this.$emit('addNewQuestion')
      } else {
        this.$emit('addNewSection')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.headerParent {
  background: white;
  padding: 20px;
  border-radius: 3px;
  margin-top: 18px;
}
.primary__button {
  background-color: #556ee6;
  padding: 8px 18px;
  box-shadow: none;
  color: white;
  border-radius: 8px;
  font-size: 13px;
  margin-right: 10px;
}
.headerParent .btn-outline-secondary {
  outline: 0 !important;
  box-shadow: none !important;
}
</style>
